import {initializeAxios} from '~/lib/accessors/axios';


export default function ({ $axios }: any) {
  initializeAxios($axios)
}
